import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CrmHelpdeskAiContentPage } from '@pages/crm';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/prompts/$promptId')({
  params: z.object({ promptId: z.uuid() }),
  component: ContentDetailRoute,
});
function ContentDetailRoute() {
  const { locale, promptId } = Route.useParams();
  return (
    <CrmHelpdeskAiContentPage
      locale={locale}
      kind="prompts"
      id={promptId}
      search={Route.useSearch()}
    />
  );
}
